module.exports = __webpack_public_path__ + "img/27.e1d2ac56.jpg";